import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TsButtonModule } from 'tsui';

import { TSIconModule } from 'tsui';
import {
  AlertBannerConfig,
  AlertTypes,
  BgClassEnum,
  IconNameEnum,
  ContentColorClassEnum,
  TYPE_CONFIG,
} from './alert-banner.types';

@Component({
  selector: 'app-alert-banner',
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule, TsButtonModule, TSIconModule],
})
export class AlertBannerComponent implements OnInit {
  @Input() public type: AlertTypes = 'info';

  public alertConfig: AlertBannerConfig = {
    bgClass: BgClassEnum.INFO,
    iconName: IconNameEnum.INFO,
    iconColorClass: ContentColorClassEnum.INFO,
    textColorClass: ContentColorClassEnum.INFO,
  };

  ngOnInit(): void {
    this.setType(this.type);
  }

  private setType(type: AlertTypes): AlertBannerConfig {
    return (this.alertConfig = TYPE_CONFIG[type] || this.alertConfig) as AlertBannerConfig;
  }
}
